import { render, staticRenderFns } from "./stats.vue?vue&type=template&id=deabeaa8&scoped=true"
import script from "./stats.vue?vue&type=script&lang=js"
export * from "./stats.vue?vue&type=script&lang=js"
import style0 from "./stats.vue?vue&type=style&index=0&id=deabeaa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deabeaa8",
  null
  
)

export default component.exports